export default __webpack_public_path__ + "static/media/gm_eshop.05d674bf.svg";